module.exports = __webpack_public_path__ + "img/headshot.377f8406.jpg";